webpackJsonp([126846490535508],{

/***/ 405:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Write Code Everyday","subtitle":"I'm interested in React, GraphQL.","copyright":"© All rights reserved.","menu":[{"label":"Articles","path":"/"},{"label":"About me","path":"/about/"},{"label":"Contact me","path":"/contact/"}],"author":{"name":"Steve Han","email":"heeinso@snu.ac.kr","github":"/heeinso","rss":"#"}}},"allMarkdownRemark":{"edges":[{"node":{"fields":{"slug":"/posts/make-a-mandalart/","categorySlug":"/categories/react-graph-ql/"},"frontmatter":{"title":"만다라트 개발 일지","date":"2018-08-05T15:30:00.962Z","category":"React, GraphQL","description":"만다라트 프로젝트의 기본 기능을 구현합시다!"}}}]}},"pathContext":{"category":"React, GraphQL"}}

/***/ })

});


// WEBPACK FOOTER //
// path---categories-react-graph-ql-c035da67f8ed38f67c5b.js